import { Broadcast, Gear, Key, SignOut } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export const TopBar = ({ channelsCount = 0, onOpenPromptSettings, onOpenApiKeys, hasKeys }) => {
  const { user, logout } = useAuth();
  return (
    <header
      data-testid="studio-topbar"
      className="h-14 border-b border-border/60 flex items-center justify-between px-6 bg-background"
    >
      <div className="flex items-center gap-3">
        <div className="w-7 h-7 bg-primary flex items-center justify-center">
          <Broadcast size={16} weight="fill" color="#fff" />
        </div>
        <div className="flex items-baseline gap-3">
          <span className="heading-font text-lg font-black tracking-tight">
            CREATOR/STUDIO
          </span>
          <span className="label-mono text-muted-foreground">
            v0.3 — phase 02
          </span>
        </div>
      </div>
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <span className="label-mono text-muted-foreground">Channels</span>
          <span
            data-testid="topbar-channel-count"
            className="font-mono text-sm font-bold tabular-nums"
          >
            {String(channelsCount).padStart(2, '0')}
          </span>
        </div>
        <button
          data-testid="open-api-keys-btn"
          onClick={onOpenApiKeys}
          className={hasKeys ? "h-9 px-3 flex items-center gap-2 border transition-colors label-mono border-border hover:border-primary hover:text-primary text-muted-foreground" : "h-9 px-3 flex items-center gap-2 border transition-colors label-mono border-primary text-primary animate-pulse-line"}
        >
          <Key size={14} weight={hasKeys ? 'regular' : 'fill'} />
          API Keys
          {!hasKeys && <span className="ml-1 h-1.5 w-1.5 bg-primary rounded-full" />}
        </button>
        <button
          data-testid="open-prompt-settings-btn"
          onClick={onOpenPromptSettings}
          className="h-9 px-3 flex items-center gap-2 border border-border hover:border-primary hover:text-primary text-muted-foreground transition-colors label-mono"
        >
          <Gear size={14} />
          Prompt Ayarlari
        </button>
        <div className="flex items-center gap-3 pl-4 border-l border-border/60">
          <span className="label-mono text-muted-foreground text-xs">{user}</span>
          <button
            data-testid="logout-btn"
            onClick={logout}
            title="Cikis Yap"
            className="h-9 px-3 flex items-center gap-2 border border-border hover:border-red-500 hover:text-red-400 text-muted-foreground transition-colors label-mono"
          >
            <SignOut size={14} />
            Cikis
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
